import {
    Directive,
    ElementRef,
    NgZone,
    AfterViewInit,
    Renderer2,
    Inject,
    ViewContainerRef,
    PLATFORM_ID,
    ChangeDetectorRef,
    OnDestroy,
    HostListener,
    Input,
    Optional
} from '@angular/core';

import _ from 'underscore';
import { DomHandler } from 'primeng/dom';
import { LocalizationService } from '../../../Core/Localization/services/localization.service';
import { UserPreferencesService } from '../../../Account/UserPreferences/services/user-preferences.service';
import { TooltipDirective } from './tooltip.directive';
import { PrimeNG } from 'primeng/config';

/**
 * our TooltipDirective only allows the tooltip postion to be top, right, left bottom..
 * this directive allows you to put the tooltip where the mouse enters the container/element
 * and I made it a seperate directive becuase we do want to have a HostListener for every single tooltip on the app
 */
@Directive({
    selector: '[agprTooltipCursor]',
    standalone: false
})
export class TooltipCursorDirective extends TooltipDirective implements AfterViewInit, OnDestroy {

    @Input('agprTooltipCursor') set textContent(text: string) {
        this.content = this.localizationService.transform(text);
        this.setOption({ tooltipLabel: this.content });
        if (this.useTooltipAsAriaLabel) {
            this.el.nativeElement.setAttribute('aria-label', this.content);
        }
    }

    mouseEnterPosition: number = 0;

    constructor(
        public el: ElementRef,
        public zone: NgZone,
        public config: PrimeNG,
        public localizationService: LocalizationService,
        public renderer2: Renderer2,
        protected viewContainerRef: ViewContainerRef,
        public cd: ChangeDetectorRef,
        @Inject(PLATFORM_ID) platformId: any,
        @Optional() protected userPrefsService: UserPreferencesService
    ) {
        super(
            el,
            zone,
            config,
            localizationService,
            renderer2,
            viewContainerRef,
            cd,
            platformId,
            userPrefsService
        );
    }

    @HostListener('mouseenter', ['$event']) onMouseEnter(e: MouseEvent) {
        if (!this.container && !this.showTimeout && e) {
            this.mouseEnterPosition = e.y;
            this.activate();
        }
    }

    // OVERRIDE
    // the tooltipPosition has to be right, and this overrides the original function in ngprime,
    // and setting the top to the position of the mouseenter
    alignRight() {
        this.preAlign('right');
        const el = this.activeElementOverride();

        const hostOffset = this.getHostOffset();
        const left = hostOffset.left + DomHandler.getOuterWidth(el);
        this.container.style.left = left + this.getOption('positionLeft') + 'px';
        this.container.style.top = (this.mouseEnterPosition - (DomHandler.getOuterHeight(this.container) / 2)) + 'px';
    }

    // OVERRIDE, since it's private, it's just a copy of "activeElement()" from ngprime
    activeElementOverride(): HTMLElement {
        return this.el.nativeElement.nodeName.includes('P-') ?
            DomHandler.findSingle(this.el.nativeElement, '.p-component') ||
            this.el.nativeElement : this.el.nativeElement;
    }
}
